<template>
  <div style="width: 98%;display: inline-block;float:left;margin-left: 20px">
    <BillTableTemplate
      :sale-edit="saleEdit"
      :sum-arr="sumArr"
      :bill-type="data[0].children"
      :table-data="notArchiveList"
      bill-name="billToDo"
      :btn-arr="billBtnAllArr"
      :page-config="pageConfig"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
      @findBillDataByBillCode="findBillDataByBillCode"
      @queryBillData="queryBillData"></BillTableTemplate>
  </div>
</template>
<script>
import publicBuill from '../../../components/reimbursement/js/publicBuill'
import BillTableTemplate from '../../../components/reimbursement/BillTableTemplate'
export default {
  components: {
    BillTableTemplate
  },
  data() {
    return {
      queryData: {
        roles: '', // 查看那些单据数据
        rejected: '', // 退回标志
        state: '' // 是否归档 1：未归档 2：已归档
      },
      billCode: '',
      jkr: '',
      activeName: 'notArchive',
      data: [{
        label: '全部',
        children: []
      }],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      pageConfig: {
        currentPage: 1,
        pageSizes: [20, 50, 100, 200],
        pageSize: 50,
        total: 0,
        status: '1',
        jeArr: [0.00, 0.00, 0.00]
      },
      notArchiveList: [],
      billBtnAllArr: [true, false, false, false],
      saleEdit: false,
      sumArr: []
    }
  },
  created() {
    publicBuill.setThis(this)
    this.saleEdit = this.getSaleEdit()
    this.data[0].children = publicBuill.getBillTree('')
    this.queryData.roles = publicBuill.getTreeValue(this.data[0].children)
    const obj = {}
    obj.label = '全部'
    obj.value = this.queryData.roles
    this.data[0].children.unshift(obj)
    this.queryBillData() // 第一次打开页面 查看 全部单据 的全部数据
  },
  methods: {
    getSaleEdit() {
      let edit = false
      const haveRoles = JSON.parse(localStorage.getItem('haveRoles'))
      haveRoles.forEach(val => {
        if (val.roleCode === 'dss-accountant-sales-check') { //销售
          edit = true
        }
      })
      return edit
    },
    handleNodeClick(data) {
      this.billCode = ''
      this.jkr = ''
      this.queryData.roles = data.value ? data.value : publicBuill.getTreeValue(this.data[0].children)
      this.activeName = 'notArchive' // 将页签切换到 全部
      this.queryBillData()
    },
    /* 每页多少条 */
    handleSizeChange(size) {
      this.pageConfig.pageSize = size
      this.queryBillData(this.param)
    },
    // 调制 第几页
    handleCurrentChange(currentpage) {
      this.pageConfig.currentPage = currentpage
      this.queryBillData(this.param)
    },
    queryBillData() {
      if (!this.queryData.roles) {
        this.$message.error('该用户缺少数据查看权限！！')
        return
      }
      const loading = this.$loading({
        lock: true,
        text: '查询中,请稍后...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const data = {
        borrower: localStorage.getItem('userName'), // 当前用户
        lrr: localStorage.getItem('userNo'), // 当前用户
        roles: this.queryData.roles, // 查看那些单据数据
        billCode: this.billCode, // 查看条件框 使用
        jkr: this.jkr !== '' ? this.jkr : null, // 查看条件框 借款人
        state: this.queryData.state, // 是否归档
        rejected: this.queryData.rejected, // 退回标志
        currentPage: this.pageConfig.currentPage, // 第几页 开始
        limit: this.pageConfig.pageSize // 每页多少条
      }
      this.$post('/fesback/statistics/toDoDoc.z', data).then(res => {
        if (res.data) {
          const failed = res.data.failed.toFixed(2)
          const passed = res.data.passed.toFixed(2)
          const paid = res.data.paid.toFixed(2)
          this.pageConfig.jeArr = [publicBuill.formatAmount(failed), publicBuill.formatAmount(passed), publicBuill.formatAmount(paid)]
          const paymentJe = publicBuill.formatAmount(res.data.paymentJe.toFixed(2))
          const approvedJe = publicBuill.formatAmount(res.data.approvedJe.toFixed(2))
          this.sumArr = ['', '合计', '', '', '', paymentJe, approvedJe]
        }
      })
      this.$post('/fesback/billData/queryToDoDoc.z', data).then(res => {
        publicBuill.tableDataFormatter(res.data.billDataList)
        this.notArchiveList = res.data.billDataList
        this.pageConfig.total = res.data.count
        loading.close()
      }).catch(res => {
        loading.close()
      })
    },
    findBillDataByBillCode(val) {
      this.queryData.roles = val.roles
      this.billCode = val.billCode
      this.jkr = val.jkr
      this.queryBillData()
    }
  }
}
</script>
